function updatePaginationLinks(sortParam) {
	const nextButton = document.getElementById("pagination-next");
	const prevButton = document.getElementById("pagination-prev");
	const paginateItems = document.querySelectorAll("#pagination_item");

	const updateButtonHref = (button) => {
		if (button) {
			const buttonUrl = new URL(button.href, window.location.origin);
			const buttonParams = new URLSearchParams(buttonUrl.search);
			buttonParams.set("sort", sortParam); // Add or update the 'sort' parameter
			buttonUrl.search = buttonParams.toString();
			button.href = buttonUrl.toString();
		}
	};

	// Update the href for all relevant buttons
	[nextButton, prevButton, ...paginateItems].forEach(updateButtonHref);
}

function handleSortButtonClick(event) {
	// Prevent default navigation
	event.preventDefault();

	const button = event.currentTarget;
	const sortParam = button.dataset.sort; // Assume sort parameter is stored in a data attribute

	if (sortParam) {
		const url = new URL(window.location.href);
		const searchParams = new URLSearchParams(url.search);

		// Update the URL's sort parameter
		searchParams.set("sort", sortParam);
		url.search = searchParams.toString();

		// Update the browser's history state and URL bar
		window.history.pushState({}, "", url.toString());

		// Update pagination links
		updatePaginationLinks(sortParam);
	}
}

// Attach event listeners to sort buttons
document.addEventListener("DOMContentLoaded", () => {
	const sortButtons = document.querySelectorAll(".sort-button");

	sortButtons.forEach((button) => {
		button.addEventListener("click", handleSortButtonClick);
	});

	// Update pagination links based on the initial URL
	const initialSortParam = new URLSearchParams(window.location.search).get(
		"sort"
	);
	if (initialSortParam) {
		updatePaginationLinks(initialSortParam);
	}
});
